<app-tag
  class="labels-tag me-2 align-self-center"
  [name]="name()"
  [color]="color()"
  [tagType]="tagType()"
  [isSystemTag]="isSystemTag()"
  [nowrap]="true"
>
  @if (
    readonly()
      ? false
      : isSystemTag()
        ? (tag() | appIsItemInArray: [SystemTag.TENANT, SystemTag.BUYER])
        : tagOwnershipType() !== TagOwnershipType.DYNAMIC
  ) {
    <i
      [class]="
        'icon icon--close c-pointer ' +
        (tag()?.ownershipType === 'SHARED'
          ? 'white-svg-color'
          : 'black-svg-color')
      "
      icon
      (click)="unassignTag.emit(tag())"
    ></i>
  }
</app-tag>
